export default __webpack_public_path__ + "static/md-image-8734b3033b2f67613ba836df2ec4fbb2.svg";